// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__xjRaw","content":"GlobalSearch_content__jD-xX"};